import { STORAGE_SESSION } from '../../constants';
import type { StorageArea } from '../../types';

export const resolveStorageArea = (storage: StorageArea): Storage => {
    return storage === STORAGE_SESSION ? sessionStorage : localStorage;
};
